export default {"src":"/_next/static/media/amplifiers.bcf5a3c5.svg","height":256,"width":352,"blurWidth":0,"blurHeight":0};